import User from '../models/User';

const USERPILOT_TOKEN = process.env.REACT_APP_USERPILOT_TOKEN;
const SDK_SRC = "https://js.userpilot.io/sdk/latest.js";

export function initUserpilot() {
    if (!USERPILOT_TOKEN) return;

    if ((window as any).__userpilot_inited) return;
    (window as any).__userpilot_inited = true;

    (window as any).userpilotSettings = { token: USERPILOT_TOKEN };

    const s = document.createElement("script");
    s.async = true;
    s.src = SDK_SRC;

    s.onload = () => {
        const token =
            (window as any).userpilot?.getToken?.() ||
            (window as any).userpilotSettings?.token ||
            "";
    };

    document.head.appendChild(s);
}

export function identifyUserpilot(user: User) {
    const userpilot = (window as any).userpilot;
    if (!userpilot || !user) return;

    const distinctId = user.userId ?? String(user.id);

    userpilot.identify(distinctId, {
        email: user.email,
        name: `${user.name}${user.lastName ? " " + user.lastName : ""}`,
        role: (user.role as any)?.name ?? (user.role as any)?.code ?? String(user.role),
        createdAt: user.AccountCreatedDT ? new Date(user.AccountCreatedDT).toISOString() : undefined,

        country: (user.country as any)?.name ?? (user.country as any)?.code,
        language: (user.language as any)?.name ?? (user.language as any)?.code,
        regions: user.regions?.map(r => (r as any)?.name ?? (r as any)?.code),

        hasAccessToContentManagement: user.hasAccessToContentManagement ?? false,
        displayMyPortfolio: user.displayMyPortfolio ?? false,
    });

    userpilot.reload?.();
}

export function reloadUserpilot() {
    (window as any).userpilot?.reload?.();
}